import { useEffect, useState } from "react";
import { IconNameEnum } from "@b2bportal/core-themes";
import { Button, Loading } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import { useSessionContext } from "../SessionContext";
import { SessionModal } from "./SessionModal";
import styles from "./SessionWidget.module.scss";
import { useNumberFormatter } from "@/utils/useNumberFormatter";

export const SessionWidget = () => {
  const { sessionInfo, elevateUser, initSession, isRefreshingPoints } =
    useSessionContext();
  const { t } = useI18nContext();
  const { format } = useNumberFormatter();

  useEffect(() => {
    initSession();
  }, [initSession]);

  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleLoginClick = () => {
    elevateUser(window.location.pathname + window.location.search);
  };

  if (!sessionInfo || !sessionInfo.userDetails) {
    return null;
  }
  const { hardAuth, pointsBalance } = sessionInfo.userDetails;

  const buttonContent = isRefreshingPoints ? (
    <Loading className={styles.spinner} />
  ) : hardAuth ? (
    t("auth.points", { points: format(pointsBalance) })
  ) : (
    t("auth.loginCTA")
  );

  return (
    <>
      <Button
        className={styles.button}
        variant="secondary"
        size="small"
        onClick={handleOpenModal}
      >
        {buttonContent}
        <Icon iconName={IconNameEnum.passengerSelection} />
        <Icon iconName={IconNameEnum.dropdownArrow} />
      </Button>
      <SessionModal
        isOpen={showModal}
        onClose={handleCloseModal}
        userDetails={sessionInfo.userDetails}
        onLoginClick={handleLoginClick}
      />
    </>
  );
};
